/**
 * Shared copy: portal users are assigned merchants directly (accountToShop), but effective
 * portal access includes child merchants under each assigned merchant.
 */

/** Add / edit user — Merchant access section */
export const PORTAL_USER_MERCHANT_ASSIGNMENT_HELPER =
  'Select merchants to assign directly. In the portal, access to a merchant includes its child merchants. Only direct assignments are shown when you edit a user or filter by merchant.';

/** Add / edit user — Merchant access when a child-merchant role is selected */
export const PORTAL_USER_CHILD_MERCHANT_MERCHANT_ASSIGNMENT_HELPER =
  'Assign the parent merchant directly. Portal access to that parent includes its child merchants—the user does not need a separate assignment for each child.';

/** Settings → Users — roster under “Users with direct access” */
export const PORTAL_USER_MERCHANT_USERS_ROSTER_HELPER =
  'Shows users directly assigned to this merchant. Users assigned to a parent merchant can still access this merchant in the portal but will not appear in this list.';

/** Grant access dialog — intro */
export const PORTAL_USER_GRANT_MERCHANT_ACCESS_INTRO =
  'Search for an existing portal user by name or email, then grant them direct access to this merchant. They will also be able to access child merchants under this merchant in the portal.';

/** Global Users — merchant filter */
export const PORTAL_USER_MERCHANT_FILTER_TOOLTIP =
  'Show users with direct access to any selected merchant. Users assigned only to a parent are not included when filtering by a child merchant.';
